import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {
    view: boolean;
}

const ManageVideosDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.VIDEO}
            view={view}
            menu_name={t('จัดการวีดีโอ')}
            menu_name_detail={t("เพิ่มวีดีโอ")}
            menu_name_detail_edit={t("รายละเอียดวีดีโอ")}
            menu_path_name={routeName.e_library.manage_podcast}
        />
    )
}

export default ManageVideosDetail